// Story 8.10 (ADO-2019), DV-37: the bar on /choose and the HHT pages, as the Figma "Select
// Depot" and HHT frames draw it: the logo, "HHT Orders" with its waiting count (only where
// the HHT workflow applies, server-decided) and the account chip; no search, Browse, depot
// tab, Depots link or cart, and no bottom tab bar. Every other page keeps `SiteHeader`,
// which carries the same "HHT Orders" link (`HhtOrdersLink`, shared markup).
//
// The logo is the way into browsing; a store user who still has to choose goes back to the
// choice screen (the browsing routes would send them there anyway, Story 8.1 AC4/AC5). The
// chip is the avatar and the active Trading Account's name, as on `SiteHeader`; before a
// choice it reads "Account". On a phone the chip is a user icon, as on `SiteHeader`.
import { Link } from 'react-router';
import { accountInitials, HhtOrdersLink, Icon, useHeaderLayout } from '../../design-system';
import { useSessionStore } from '../../auth/useSessionStore';
import { useHhtWaitingCountStore } from '../../hht/useHhtWaitingCountStore';
import { CHOOSE_ROUTE, PRODUCTS_ROUTE } from '../../ordering/orderingChoices';
import { requiresOrderingChoice } from '../../ordering/orderingSession';
import { headerAccountName } from '../Products/useHeaderChrome';
import styles from './ChooserHeader.module.css';

const HHT_LINK_CLASSES = { link: styles.hhtLink, label: styles.hhtLabel, badge: styles.hhtBadge };

export function ChooserHeader() {
  const brand = useSessionStore((s) => s.brandConfig);
  const mustChoose = useSessionStore(requiresOrderingChoice);
  const account = useSessionStore((s) => s.activeTradingAccount);
  // DV-39: the cheap count only, so a failure of the classified details never hides it.
  const hhtApplies = useHhtWaitingCountStore((s) => s.applies);
  const hhtWaitingCount = useHhtWaitingCountStore((s) => s.waitingCount);
  const mobile = useHeaderLayout() === 'mobile';
  const accountLabel = headerAccountName(account) ?? '';
  const accountAvatar = accountInitials(accountLabel);
  const accountName = accountLabel === '' ? 'Account' : accountLabel;

  return (
    <header className={styles.header} data-themed={brand.themed ? 'true' : undefined}>
      <Link to={mustChoose ? CHOOSE_ROUTE : PRODUCTS_ROUTE} className={styles.logo}>
        <img src={brand.logoUrl} alt={brand.name} className={styles.logoImg} />
      </Link>
      <div className={styles.end}>
        {hhtApplies ? (
          <HhtOrdersLink waitingCount={hhtWaitingCount} classes={HHT_LINK_CLASSES} />
        ) : null}
        {mobile ? (
          <Link
            to="/account"
            className={styles.accountIcon}
            aria-label={accountLabel === '' ? 'Account' : `Account, ${accountLabel}`}
          >
            <Icon name="user" size={22} />
          </Link>
        ) : (
          <Link to="/account" className={styles.chip}>
            <span className={styles.avatar} aria-hidden>
              {accountAvatar === '' ? <Icon name="user" size={16} /> : accountAvatar}
            </span>
            <span className={styles.chipName}>{accountName}</span>
          </Link>
        )}
      </div>
    </header>
  );
}
